import { ref } from 'vue';

// Shared across audio bubbles for the lifetime of this browser session.
export const playbackSpeed = ref(1);
